import {
  InputGroup as ChakraInputGroup,
  Checkbox, Flex, FormControl,
  FormErrorMessage,
  InputLeftElement
} from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { DatepickerPopup, FormLabel } from '@/components'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Calendar } from '@/icons'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'

export const AdditionalPropertyInfoGcp = () => {
  const { insuranceParams } = useInsuranceParams()

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const { error: notOwnerPropertyLossError } = getFieldState('property.additionalDataGcp.notOwnerPropertyLoss')
  const { error: notOwnerPropertyResponsibilityLossError } = getFieldState('property.additionalDataGcp.notOwnerPropertyResponsibilityLoss')
  const { error: startConstructionDateError } = getFieldState('property.additionalDataGcp.startConstructionDate')

  const notOwnerPropertyLossRequired = getValues('property.additionalDataGcp.notOwnerPropertyLossRequired')
  const notOwnerPropertyResponsibilityLossRequired = getValues('property.additionalDataGcp.notOwnerPropertyResponsibilityLossRequired')
  const startConstructionDateRequired = getValues('property.additionalDataGcp.startConstructionDateRequired')

  const startConstructionDate = getValues('property.additionalDataGcp.startConstructionDate')

  return (
    <>
      {notOwnerPropertyLossRequired &&
        <FormControl isInvalid={!!notOwnerPropertyLossError?.message}>
          <Flex sx={{ gap: 2 }}>
            <Checkbox {...register('property.additionalDataGcp.notOwnerPropertyLoss')} isDisabled={isContracted}>
              Pojišťovaný majetek nevlastní výhradně pojistník. Hrozí mu přesto bez jeho existence či uchování přímá majetková ztráta?
            </Checkbox>

          </Flex>
          {<FormErrorMessage>{notOwnerPropertyLossError?.message}</FormErrorMessage>}
        </FormControl>
      }

      {notOwnerPropertyResponsibilityLossRequired &&
        <FormControl isInvalid={!!notOwnerPropertyResponsibilityLossError?.message}>
          <Flex sx={{ gap: 2 }}>
            <Checkbox {...register('property.additionalDataGcp.notOwnerPropertyResponsibilityLoss')} isDisabled={isContracted}>
              Hrozí pojistníkovi přímá majetková ztráta, pokud pojištěná osoba bude povinna nahradit jiné osobě vzniklou újmu? V případě kdy majetková ztráta nehrozí a pojištěná osoba není zároveň pojistníkem nelze pojištění odpovědnosti sjednat.
            </Checkbox>

          </Flex>
          {<FormErrorMessage>{notOwnerPropertyResponsibilityLossError?.message}</FormErrorMessage>}
        </FormControl>
      }


      {startConstructionDateRequired &&
        <FormControl isRequired isInvalid={!!startConstructionDateError?.message}>
          <FormLabel htmlFor="pnameof(x => x.birthday)">Datum zahájení stavby</FormLabel>

          <ChakraInputGroup>
            <InputLeftElement pointerEvents="none" children={<Calendar width={4} height={4} />} />
            <DatepickerPopup
              isDisabled={isContracted}
              date={startConstructionDate ? new Date(startConstructionDate) : undefined}
              onDateChange={(date: Date) => setValue('property.additionalDataGcp.startConstructionDate', date)}
            />
          </ChakraInputGroup>
          <FormErrorMessage>{startConstructionDateError?.message}</FormErrorMessage>
        </FormControl>
      }
    </>
  )
}
